export const cleanData = (data) => {

    if (data === null) {
        return null;
    }

    // Ensure to not touch the UI model, but instead make a deep copy
    const jsonData = JSON.stringify(data);
    const clonedData = JSON.parse(jsonData);

    // Clean any stringified identifiers to reset as integer
    return fixIdFields(clonedData);
};

const fixIdFields = (data) => {

    if (data === null) {
        return null;
    }

    if (Array.isArray(data)) {
        return data.map(entry => cleanData(entry));
    }

    if (typeof data === 'object') {
        const cleanedData = {};
        for (const [key, value] of Object.entries(data)) {
            if (value === undefined || value === null) {
                cleanedData[key] = value;
            } else if (typeof value === 'object') {
                cleanedData[key] = cleanData(value);
            } else if (key === 'id' && typeof value === 'string') {
                cleanedData.id = 0;
            } else if (key === 'feedbackFieldId' && typeof value === 'string') {
                cleanedData.feedbackFieldId = 0;
            } else {
                cleanedData[key] = value;
            }
        }

        return cleanedData;
    }

    return data;
};
